import 'moment-timezone';
import moment from "moment"
import { IUserModel } from "./UserModel";
import { GetValue, IgnoreTimeZoneApiDate } from "../../Helpers/helper";

export interface ICompanyModel {
    Id: number;
    Name?: string;
    TimeLimit?: Date;
    AmountDays?: number;
    Created?: Date;
    CreatedById: number;
    Modified?: Date;
    IsActive?: boolean;

    //#region Setters

    SetID: (id: number) => ICompanyModel;
    SetName: (name: string) => ICompanyModel;
    SetTimeLimit: (time: Date) => ICompanyModel;
    SetAmountDays: (days: number) => ICompanyModel;
    SetCreated: (createdAt: Date) => ICompanyModel;
    SetCreatedById: (id: number) => ICompanyModel;
    SetModified: (modifiedAt: Date) => ICompanyModel;
    SetIsActive: (isActive: boolean) => ICompanyModel;

    //#endregion

    Clone: () => ICompanyModel;

    LoadFromAPI: (response: any) => ICompanyModel;
    LoadFromCached: (model: any) => ICompanyModel;
    ToJson: () => string;
}

export default class CompanyModel implements ICompanyModel {
    Id: number;
    Name?: string;
    TimeLimit?: Date;
    AmountDays: number;
    Created?: Date;
    CreatedById: number;
    Modified?: Date;
    IsActive?: boolean;

    constructor(userLogged?: IUserModel) {
        this.Id = this.AmountDays = this.CreatedById = 0;
        this.CreatedById = userLogged?.Id || 0;
        this.Created = this.Modified = moment().toDate();
        this.IsActive = true;
    }

    //#region Setters

    SetAmountDays = (days: number): ICompanyModel => {
        this.AmountDays = days!;
        return this;
    }

    SetCreated = (createdAt: Date): ICompanyModel => {
        this.Created = createdAt!;
        return this;
    }

    SetCreatedById = (id: number): ICompanyModel => {
        this.CreatedById = id!;
        return this;
    }

    SetID = (id: number): ICompanyModel => {
        this.Id = id!
        return this;
    }

    SetIsActive = (isActive: boolean): ICompanyModel => {
        this.IsActive = isActive!;
        return this;
    }

    SetModified = (modifiedAt: Date): ICompanyModel => {
        this.Modified = modifiedAt!;
        return this;
    }

    SetName = (name: string): ICompanyModel => {
        this.Name = name!.trim();
        return this;
    }

    SetTimeLimit = (time: Date): ICompanyModel => {
        this.TimeLimit = time!;
        return this;
    }

    //#endregion

    Clone = (): ICompanyModel => {
        const result = new CompanyModel()
            .SetAmountDays(this.AmountDays)
            .SetCreated(this.Created!)
            .SetCreatedById(this.CreatedById)
            .SetID(this.Id)
            .SetIsActive(this.IsActive!)
            .SetModified(this.Modified!)
            .SetName(this.Name!)
            .SetTimeLimit(this.TimeLimit!);

        return result
    };

    LoadFromAPI = (response: any): ICompanyModel => {
        const apiCreated: string = GetValue(response, "Created"),
            apiModified: string = GetValue(response, "Modified"),
            apiTimeLimit: string = GetValue(response, "timeLimit");

        this.Id = GetValue(response, "companyId") as number;
        this.Name = GetValue(response, "name") as string;
        this.TimeLimit = (apiTimeLimit && IgnoreTimeZoneApiDate(apiTimeLimit)) || this.TimeLimit;
        this.AmountDays = GetValue(response, "amountDays") as number;
        this.Created = (apiCreated && IgnoreTimeZoneApiDate(apiCreated)) || this.Created;
        this.CreatedById = GetValue(response, "createdById") as number;
        this.Modified = (apiModified && IgnoreTimeZoneApiDate(apiModified)) || this.Modified;
        this.IsActive = GetValue(response, "isActive") as boolean;

        return this;
    }

    LoadFromCached = (model: any): ICompanyModel => {

        this.LoadFromAPI(model);

        this.Id = GetValue(model, "Id") as number;

        return this;
    }

    ToJson = (): string => {

        const dto = {
            companyId: this.Id,
            name: this.Name?.trim(),
            timeLimit: moment(this.TimeLimit).format(),
            amountDays: this.AmountDays,
            created: moment(this.Created).format(),
            createdById: this.CreatedById,
            modified: moment(this.Modified).format(),
            isActive: this.IsActive
        },
            result = JSON.stringify(dto);

        return result;
    };
}